// import { Pipe, PipeTransform } from "@angular/core";
// import { SensorModel } from "../models/sensor.model";

// @Pipe({
//   name: "sensorFilterPipe",
// })
// export class SensorFilterPipe implements PipeTransform {
//   transform(sensors: Array<SensorModel>, searchStr: string): any {
//     console.log(searchStr);
//     searchStr = searchStr.toString().toLowerCase();
//     console.log(searchStr);
//     const filteredSensors: Array<SensorModel> = [];
//     if (searchStr.length === 0) {
//       return sensors;
//     }
//     console.log("Sensors: ", sensors);
//     for (const sensor of sensors) {
//       if (
//         sensor.status.toLowerCase().indexOf(searchStr) !== -1 ||
//         sensor.id.toString().indexOf(searchStr) !== -1 ||
//         (sensor.serverName &&
//           sensor.serverName.toLowerCase().indexOf(searchStr) !== -1) ||
//         sensor.serverId.toString().indexOf(searchStr) !== -1 ||
//         sensor.softwareVersion.toLowerCase().indexOf(searchStr) !== -1 ||
//         (sensor.hardwareName &&
//           sensor.hardwareName.toLowerCase().indexOf(searchStr) !== -1) ||
//         (sensor.macWlan &&
//           sensor.macWlan.toLowerCase().indexOf(searchStr) !== -1) ||
//         (sensor.macEth !== null &&
//           sensor.macEth.toString().toLowerCase().indexOf(searchStr) !== -1)
//       ) {
//         console.log("filtered Sensors: ", sensor.id);
//         filteredSensors.push(sensor);
//       }
//     }
//     console.log("filtered Sensors: ", filteredSensors);
//     return filteredSensors;
//   }
// }

import { Pipe, PipeTransform } from "@angular/core";
import { SensorModel } from "../models/sensor.model";

@Pipe({
  name: "sensorFilterPipe",
})
export class SensorFilterPipe implements PipeTransform {
  transform(sensors: Array<SensorModel>, searchStr: string): any {
    if (!sensors || !searchStr) {
      // sensors나 searchStr이 없을 경우 원래 배열 반환
      return sensors;
    }

    searchStr = searchStr.toString().toLowerCase();

    const filteredSensors: Array<SensorModel> = [];
    for (const sensor of sensors) {
      if (
        this.checkValue(sensor.status, searchStr) ||
        this.checkValue(sensor.id, searchStr) ||
        this.checkValue(sensor.serverName, searchStr) ||
        this.checkValue(sensor.serverId, searchStr) ||
        this.checkValue(sensor.softwareVersion, searchStr) ||
        this.checkValue(sensor.hardwareName, searchStr) ||
        this.checkValue(sensor.macWlan, searchStr) ||
        this.checkValue(sensor.macEth, searchStr)
      ) {
        filteredSensors.push(sensor);
      }
    }
    return filteredSensors;
  }

  private checkValue(field: any, searchStr: string): boolean {
    // null 또는 undefined 값을 처리하고 toString 호출 안전화
    return (
      field !== null &&
      field !== undefined &&
      field.toString().toLowerCase().includes(searchStr)
    );
  }
}
